export enum PdfTextAlign {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

export enum PdfTextVariant {
  contained,
  outlined,
  alternated,
  text,
}

export enum PdfFontSizes {
  text = 9,
  h1 = 11,
  h2 = 10,
}

export const pdfStyles = {
  colors: {
    gray: [0.7, 0.7, 0.7],
    lightGray: [0.8, 0.8, 0.8],
    lighterGray: [0.9, 0.9, 0.9],
  },
  margins: {
    top: 25,
    page: 30, // side margins
    text: 3,
  },
  dimensions: {
    heights: {
      logo: 20,
      row: 20,
    },
    width: {
      border: 0.5,
      container: 580,
    },
  },
  opacity: 0.5,
  offsets: {
    x: 8,
    y: 8,
  },
};

export const applicationS3Path = 'insurance/policies/apply/RMA';
